import React from 'react'
import images from '../../ressources/images'
import Cookies from "universal-cookie"

function SplashScreen() {
  const style = {
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "70%",
    height: "100vh"
  }

  const cookies = new Cookies();
  const theme = cookies.get('theme')

  return (
    <div style={style}>
      <img src={images['logo_' + theme]} alt=""/>
    </div>
  )
}

export default SplashScreen
